import React, { Component } from "react";
import { Container, Header, Footer} from '@deere/ux.uxframe-react';
import CompanyleftHeader from '../company/components/company-left-header';
import Select from '../reusable/components/Select';
import Input from "../reusable/components/Input";
import Button from "../reusable/components/Button.jsx";
import SuccessMsg from "../reusable/components/SuccessMessage.jsx";
import ErrorMsg from "../reusable/components/ErrorMessage.jsx";
import baseurl from "../api-properties";
import TextArea from '../reusable/components/TextArea';
import {getAuthToken} from "../reusable/basic-auth-creds";

class DiversityFinacialInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMsg: "",
            errorMsg: "",
            prosNumber: this.props.match.params.value,
            prosSuppId: 0,
            companyInfo: [],
            diversityInfoJson: [],
            geographicalJson: [],
            businessTypeOptions: [],
            prevYearSalesOptions: [],
            showClassifications: false,
            showCurrencyRate: false,
            currencyRate: "",
            showYear1Currency: false,
            showYear2Currency: false,
            showYear3Currency: false,
            prevYear1ConvAmt: "",
            prevYear2ConvAmt: "",
            prevYear3ConvAmt: "",
            currencyRateInUSD: "",
            showDiversity: false,
            isFinancialDataExist: false,
            standardCertOptions: [],
            standardCertFileList: [],
            standardCertSelectedFile: "",
            comments: "",
            formValue: {
                prosSuppId: 0, proSuppCertCd: "", businessTypeCd: "", tradedCd: "", ownerLegalName: "", establishedYear: "", noFacilities: "",
                noTotalEmployee: "", prevYearCurrencyCd: "", prevYearValue1: "", prevYearValue2: "", prevYearValue3: "",
                prevYearTitle1: "", prevYearTitle2: "", prevYearTitle3: "", standardCerts: "",comments: ""
            },
            formErrors: {
                proSuppCertCd: "", proSuppCerts: "", businessTypeCd: "", tradedCd: "", ownerLegalName: "", establishedYear: "", noFacilities: "",
                noTotalEmployee: "", proGeographical: "", prevYearCurrencyCd: "", prevYearValue1: "", prevYearValue2: "", prevYearValue3: "",
                showError: false, standardCerts: []
            }
        };
        this.handleInput = this.handleInput.bind(this);
    }

    componentDidMount() {
        let prosNumber = this.state.prosNumber;
        this.loadSupplierDetails(prosNumber);
    }

    loadSupplierDetails = (prosNumber) => {
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/getSupplier/" + prosNumber + "/NULL", {
            method: "GET",
            headers: {
                "Authorization": "Basic " + getAuthToken()
            }
        })
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null) {
                    this.setState({ companyInfo: data });
                    let prosSuppId = data.prosSuppId;
                    this.setState({ prosSuppId: prosSuppId });

                    let formValueObj = this.state.formValue;
                    formValueObj.proSuppCertCd = data.diverseCert;
                    this.setState({ formValue: formValueObj });

                    if (this.state.companyInfo.country === "US")
                        this.setState({ showDiversity: true });
                    if (formValueObj.proSuppCertCd === "Y")
                        this.setState({ showClassifications: true });

                    this.loadDiversityInfo(prosSuppId);
                    this.loadGeographicalList(prosSuppId);
                    this.loadFinacialInfo(prosSuppId);
                    this.loadBusinessTypesOptions();
                    this.loadPrevYearSalesOptions();
                    this.loadStandardCertOptions();
                    this.loadCertFiles(prosSuppId);
                }
            }).catch(error => {
                console.log(error);
            });
    }

    loadDiversityInfo = (prosSuppId) => {
        fetch(baseurl.DIVERSITY_API_URL + "diversity/getCertifications/" + prosSuppId, {
                method: "GET",
                headers: {
                    "Authorization": "Basic " + getAuthToken()
                }
            }
        )
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null)
                    this.setState({ diversityInfoJson: data });
            }).catch(error => {
                console.log(error);
            });
    }

    loadGeographicalList = (prosSuppId) => {
        fetch(baseurl.FINACIAL_API_URL + "financial/getGeographical/" + prosSuppId, {
                method: "GET",
                headers: {
                    "Authorization": "Basic " + getAuthToken()
                }
            }
        )
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null)
                    this.setState({ geographicalJson: data });
            }).catch(error => {
                console.log(error);
            });
    }

    loadFinacialInfo = (prosSuppId) => {
        fetch(baseurl.FINACIAL_API_URL + "/financial/getFinancial/" + prosSuppId, {
                method: "GET",
                headers: {
                    "Authorization": "Basic " + getAuthToken()
                }
            }
        )
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null) {
                    let formValueObj = this.state.formValue;

                    formValueObj.prosSuppId = data.prosSuppId;
                    formValueObj.businessTypeCd = data.businessTypeCd;
                    formValueObj.tradedCd = data.tradedCd;
                    formValueObj.ownerLegalName = data.ownerLegalName;
                    formValueObj.establishedYear = data.establishedYear;
                    formValueObj.noFacilities = data.noFacilities;
                    formValueObj.noTotalEmployee = data.noTotalEmployee;
                    formValueObj.prevYearCurrencyCd = data.prevYearCurrencyCd;
                    if (data.prevYearValue1 !== 0)
                        formValueObj.prevYearValue1 = data.prevYearValue1;
                    if (data.prevYearValue2 !== 0)
                        formValueObj.prevYearValue2 = data.prevYearValue2;
                    if (data.prevYearValue3 !== 0)
                        formValueObj.prevYearValue3 = data.prevYearValue3;
                    formValueObj.prevYearTitle1 = data.prevYearTitle1;
                    formValueObj.prevYearTitle2 = data.prevYearTitle2;
                    formValueObj.prevYearTitle3 = data.prevYearTitle3;
                    formValueObj.comments = data.comments;

                    this.setState({ formValue: formValueObj });
                    this.loadConversionRateForm(formValueObj);
                    this.setState({ isFinancialDataExist: data.isDataExist });
                } else {
                    this.setState({ isFinancialDataExist: false });
                }
            }).catch(error => {
                console.log(error);
            });
    }

    loadConversionRateForm = (formValueObj) => {
        fetch(baseurl.CURRENCY_API_URL + "currency/getCurrencyRate/" + formValueObj.prevYearCurrencyCd)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null) {
                    this.setState({ currencyRate: data.exchangeRateFromUSD })
                    this.setState({ currencyRateInUSD: data.exchangeRateToUSD })
                    this.loadCurrencyValue(formValueObj, this.state.currencyRateInUSD);
                }
            }).catch(error => {
                console.log(error);
            });
    }

    loadCertFiles = (prosSuppId) => {
        fetch(baseurl.FINACIAL_API_URL + "financial/retrieveFileName/" + prosSuppId, {
                method: "GET",
                headers: {
                    "Authorization": "Basic " + getAuthToken()
                }
            }
        )
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null && data.length > 0) {
                    this.setState({ standardCertFileList: data });
                } else {
                    let standardCertFileList = [];
                    standardCertFileList.push('Select a file')
                    this.setState({ standardCertFileList });
                }
            }).catch(error => {
                console.log(error);
            });
    }

    loadCurrencyValue = (formValueObj, currencyRateInUSD) => {
        if (formValueObj.prevYearCurrencyCd != null && formValueObj.prevYearCurrencyCd !== "USD" && formValueObj.prevYearCurrencyCd !== "") {
            this.setState({ showCurrencyRate: true });
        }

        if (formValueObj.prevYearValue1 !== "" && formValueObj.prevYearValue1 != null && this.state.showCurrencyRate === true && formValueObj.prevYearCurrencyCd !== "USD") {
            let convertedVal = formValueObj.prevYearValue1 * currencyRateInUSD;
            let roundedVal = Math.floor(convertedVal * 100) / 100;
            this.setState({ prevYear1ConvAmt: roundedVal });
            this.setState({ showYear1Currency: true });
        }

        if (formValueObj.prevYearValue2 !== "" && formValueObj.prevYearValue2 != null && this.state.showCurrencyRate === true && formValueObj.prevYearCurrencyCd !== "USD") {
            let convertedVal = formValueObj.prevYearValue2 * currencyRateInUSD;
            let roundedVal = Math.floor(convertedVal * 100) / 100;
            this.setState({ prevYear2ConvAmt: roundedVal });
            this.setState({ showYear2Currency: true });
        }

        if (formValueObj.prevYearValue3 !== "" && formValueObj.prevYearValue3 != null && this.state.showCurrencyRate === true && formValueObj.prevYearCurrencyCd !== "USD") {
            let convertedVal = formValueObj.prevYearValue3 * currencyRateInUSD;
            let roundedVal = Math.floor(convertedVal * 100) / 100;
            this.setState({ prevYear3ConvAmt: roundedVal });
            this.setState({ showYear3Currency: true });
        }
    }

    loadBusinessTypesOptions = () => {
        let jsonData = { "paramCategory": "BUSINESS_TYPE" };
        fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParams/", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                     }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        }).then(data => {
            if (data !== undefined && data != null) {
                let businessTypes = data.map(result => { return { value: result.paramCode, display: result.paramValue } })
                this.setState({ businessTypeOptions: [{ value: '', display: 'Select...' }].concat(businessTypes) });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    loadPrevYearSalesOptions = () => {
        let jsonData = { "paramCategory": "CURRENCY_CODES" };
        fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParams/", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        }).then(data => {
            if (data !== undefined && data != null) {
                let prevYearSales = data.map(result => { return { value: result.paramCode, display: result.paramCode } })
                this.setState({ prevYearSalesOptions: [{ value: '', display: 'Select Currency' }].concat(prevYearSales) });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    loadStandardCertOptions = () => {
        let jsonData = { "paramCategory": "CERTIFIED_TYPE" };
        fetch(baseurl.PROS_SUPNET_API_URL + "ps/getParams/", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        }).then(data => {
            if (data !== undefined && data != null) {
                let standardCertList = data.map(result => { return { value: result.paramCode, display: result.paramValue } })
                this.setState({ standardCertOptions: [{ value: '', display: 'Select...' }].concat(standardCertList) });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    loadConversionRate = (prevYearCurrencyCd) => {
        fetch(baseurl.CURRENCY_API_URL + "currency/getCurrencyRate/" + prevYearCurrencyCd)
            .then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.json();
            })
            .then(data => {
                if (data !== undefined && data != null) {
                    this.setState({ currencyRate: data.exchangeRateFromUSD })
                    this.setState({ currencyRateInUSD: data.exchangeRateToUSD })
                }
            }).catch(error => {
                console.log(error);
            });
    }

    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(
            prevState => ({
                formValue: {
                    ...prevState.formValue,
                    [name]: value
                }
            }),
            () => { this.updateInputField(name, value) }
        );
    }

    updateInputField = (name, value) => {
        let currencyshow = true;
        let currancyVal = "";
        if (name === "proSuppCertCd" && value === "N") {
            this.state.diversityInfoJson.map((diversityObj) => {
                diversityObj.isSelected = false;
            })
            this.setState({ showClassifications: false });
        } else if (name === "proSuppCertCd" && value === "Y") {
            this.setState({ showClassifications: true });
        }
        if (name === "prevYearCurrencyCd") {
            if (value !== "USD") {
                this.loadConversionRate(value);
                currancyVal = value;
                this.setState({ showCurrencyRate: true });
                this.setState({ showYear1Currency: true });
                this.setState({ showYear2Currency: true });
                this.setState({ showYear3Currency: true });
                currencyshow = true;
            } else {
                this.setState({ showCurrencyRate: false });
                this.setState({ showYear1Currency: false });
                this.setState({ showYear2Currency: false });
                this.setState({ showYear3Currency: false });
                currencyshow = false;
            }
        }

        if (name === "prevYearValue1" && currencyshow === true && value !== "") {
            let convertedVal = value * this.state.currencyRateInUSD;
            let roundedVal = Math.floor(convertedVal * 100) / 100;
            this.setState({ prevYear1ConvAmt: roundedVal });
        } else if (this.state.formValue.prevYearValue1 !== "" && currancyVal !== "") {
            this.state.formValue.prevYearCurrencyCd = currancyVal;
            this.loadConversionRateForm(this.state.formValue, this.state.currencyRateInUSD);
        }

        if (name === "prevYearValue2" && currencyshow === true && value !== "") {
            let convertedVal = value * this.state.currencyRateInUSD;
            let roundedVal = Math.floor(convertedVal * 100) / 100;
            this.setState({ prevYear2ConvAmt: roundedVal });
        } else if (this.state.formValue.prevYearValue2 !== "" && currancyVal !== "") {
            this.state.formValue.prevYearCurrencyCd = currancyVal;
            this.loadConversionRateForm(this.state.formValue, this.state.currencyRateInUSD);
        }

        if (name === "prevYearValue3" && currencyshow === true && value !== "") {
            let convertedVal = value * this.state.currencyRateInUSD;
            let roundedVal = Math.floor(convertedVal * 100) / 100;
            this.setState({ prevYear3ConvAmt: roundedVal });
        } else if (this.state.formValue.prevYearValue3 !== "" && currancyVal !== "") {
            this.state.formValue.prevYearCurrencyCd = currancyVal;
            this.loadConversionRateForm(this.state.formValue, this.state.currencyRateInUSD);
        }

        if (name === "proSuppCerts") {
            let jsonData = this.state.diversityInfoJson;
            jsonData.map((diversityObj) => {
                if (value === diversityObj.proSuppCertId) {
                    (diversityObj.isSelected === true) ? diversityObj.isSelected = false : diversityObj.isSelected = true;
                }
            })
            this.setState({ diversityInfoJson: jsonData });
        }

        if (name === "geographicalChk") {
            let jsonData = this.state.geographicalJson;
            jsonData.map((geographicalObj) => {
                if (value === geographicalObj.geographicalId) {
                    (geographicalObj.isSelected === true) ? geographicalObj.isSelected = false : geographicalObj.isSelected = true;
                }
            })
            this.setState({ geographicalJson: jsonData });
        }
    }

    onClickContinue = (e) => {
        this.saveDiversityFinancialInfo(e, true);
    }

    onClickSave = (e) => {
        this.saveDiversityFinancialInfo(e, false);
    }

    saveStandardCertFile = e => {
        let prosSuppId = this.state.prosSuppId;
        let fileIndex = e.target.getAttribute("indexcount");
        let standardCertificate = this.state.formValue.standardCerts;
        let fieldErrors = this.state.formErrors;
        let isValid = false;
        fieldErrors.standardCerts[fileIndex] = "";
        this.setState({ standardCertSelectedFile: "" });

        if (!this.checkNull(standardCertificate) || standardCertificate.length <= 0) {
            fieldErrors.standardCerts[fileIndex] = "Please select Standard Certifications option first then browse a file.";
            isValid = true;
        }

        if (e.target.files.length > 0) {
            this.setState({ standardCertSelectedFile: e.target.files[0].name });
            let fileName = e.target.files[0].name;
            let jsonData = this.state.standardCertFileList;
            jsonData.map((standardCertFileObj) => {
                if (standardCertFileObj !== null && standardCertFileObj !== undefined &&
                    standardCertFileObj.split('|')[2] !== undefined && fileName === standardCertFileObj.split('|')[2].trim()) {
                    fieldErrors.standardCerts[fileIndex] = "Please select another file, selected file already uploaded to this request.";
                    isValid = true;
                }
            })
        }

        if (isValid) {
            fieldErrors.showError = true;
            this.setState({ formErrors: fieldErrors });
        } else {
            fieldErrors.showError = false;
            this.setState({ formErrors: fieldErrors });
        }
        if (e.target.files.length > 0 && !isValid) {
            const data = new FormData();
            data.append('file', e.target.files[0]);
            fetch(baseurl.FINACIAL_API_URL + "financial/uploadFile/" + prosSuppId + "/" + standardCertificate, {
                method: "POST",
                body: data,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Basic " + getAuthToken()
                }
            }).then(response => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.text();
            }).then(data => {
                if (data !== undefined && data != null) {
                    this.setState({ successMsg: 'File Uploaded Successfully' });
                    window.scrollTo(0, 0);
                    this.loadCertFiles(this.state.prosSuppId);
                }
            }).catch(error => {
                console.log(error);
                this.setState({ errorMsg: error.message });
                window.scrollTo(0, 0);
            });
        }
    };

    addStandardCertFile = () => {
        let fieldErrors = this.state.formErrors;
        let fileIndex = 4;
        let standardCertFileList = [...this.state.standardCertFileList];
        this.setState({ standardCertSelectedFile: "" });
        if (standardCertFileList.length < 5) {
            standardCertFileList.push('Select a file')
            this.setState({ standardCertFileList });
            fieldErrors.standardCerts[fileIndex] = "";
            fieldErrors.showError = false;
        } else {
            fieldErrors.standardCerts[fileIndex] = "You can attached maximum 5 files to each request.";
            fieldErrors.showError = true;
        }
        this.setState({ formErrors: fieldErrors });
    };



    downloadStandardCertFile = (e, fileName) => {
        e.preventDefault();
        fileName = fileName.replace(/\|/g, ':');
        fetch(baseurl.FINACIAL_API_URL + "financial/downloadFile/?fileName=" + fileName, {
                method: "GET",
                headers: {
                    "Authorization": "Basic " + getAuthToken()
                }
            })
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                return response.text();
            }).then(data => {
                if (data !== undefined && data != null) {
                    window.open(data, "_blank");
                }
            }).catch(error => {
                console.log(error);
            });
    }

    deleteStandardCertFile = (e, fileName) => {
        e.preventDefault();
        fileName = fileName.replace(/\|/g, ':');
        fetch(baseurl.FINACIAL_API_URL + "financial/deleteFile", {
            method: "POST",
            body: fileName,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            this.setState({ successMsg: "File Deleted Successfully" });
            window.scrollTo(0, 0);
            this.loadCertFiles(this.state.prosSuppId);
        }).catch(error => {
            console.log(error);
        });
    }

    validateOnSubmit = () => {
        let fieldErrors = this.state.formErrors;
        let error = this.validationMessage();
        if (error) {
            fieldErrors.showError = true;
            this.setState({ formErrors: fieldErrors });
        } else {
            fieldErrors.showError = false;
            this.setState({ formErrors: fieldErrors });
        }
        return !error;
    };

    validationMessage = () => {
        let fieldErrors = this.state.formErrors;
        let isValid = "";
        if (this.state.showDiversity === true) {
            if (!this.checkNull(this.state.formValue.proSuppCertCd) || this.state.formValue.proSuppCertCd.length <= 0) {
                fieldErrors.proSuppCertCd = "Please select Small Diverse Certified Supplier.";
                isValid = true;
            } else fieldErrors.proSuppCertCd = "";

            if (this.checkNull(this.state.formValue.proSuppCertCd) &&
                this.state.formValue.proSuppCertCd === "Y" &&
                this.getCheckboxCount(this.state.diversityInfoJson) <= 0) {
                fieldErrors.proSuppCerts = "Please select Diverse Classification.";
                isValid = true;
            } else fieldErrors.proSuppCerts = "";
        }

        if (!this.checkNull(this.state.formValue.businessTypeCd) || this.state.formValue.businessTypeCd.length <= 0) {
            fieldErrors.businessTypeCd = "Business Type is required field.";
            isValid = true;
        } else fieldErrors.businessTypeCd = "";

        if (!this.checkNull(this.state.formValue.tradedCd) || this.state.formValue.tradedCd.length <= 0) {
            fieldErrors.tradedCd = "Please select Traded Type.";
            isValid = true;
        } else fieldErrors.tradedCd = "";

        if (!this.checkNull(this.state.formValue.ownerLegalName) || this.state.formValue.ownerLegalName.length <= 0) {
            fieldErrors.ownerLegalName = "Owner Legal Name is required field.";
            isValid = true;
        } else fieldErrors.ownerLegalName = "";

        if (!this.checkNull(this.state.formValue.establishedYear) || this.state.formValue.establishedYear.length <= 0) {
            fieldErrors.establishedYear = "Year Established is required field.";
            isValid = true;
        } else if (!this.checkNull(this.state.formValue.establishedYear) || this.state.formValue.establishedYear > this.state.companyInfo.currentYear) {
            fieldErrors.establishedYear = "Year Established cannot be future date.";
            isValid = true;
        } else fieldErrors.establishedYear = "";

        if (!this.checkNull(this.state.formValue.noFacilities) || this.state.formValue.noFacilities.length <= 0) {
            fieldErrors.noFacilities = "Number of Facilities is required field.";
            isValid = true;
        } else fieldErrors.noFacilities = "";

        if (!this.checkNull(this.state.formValue.noTotalEmployee) || this.state.formValue.noTotalEmployee.length <= 0) {
            fieldErrors.noTotalEmployee = "Total Number of Employees is required field.";
            isValid = true;
        } else fieldErrors.noTotalEmployee = "";

        if (this.getCheckboxCount(this.state.geographicalJson) <= 0) {
            fieldErrors.proGeographical = "Please select Geographical Service Area.";
            isValid = true;
        } else fieldErrors.proGeographical = "";

        if (!this.checkNull(this.state.formValue.prevYearCurrencyCd) || this.state.formValue.prevYearCurrencyCd.length <= 0) {
            fieldErrors.prevYearCurrencyCd = "Previous Years Sales is required field.";
            isValid = true;
        } else fieldErrors.prevYearCurrencyCd = "";

        if (!this.checkNull(this.state.formValue.prevYearValue1) || this.state.formValue.prevYearValue1.length <= 0) {
            fieldErrors.prevYearValue1 = "Previous Year1 Value is required field.";
            isValid = true;
        } else fieldErrors.prevYearValue1 = "";

        if (!this.checkNull(this.state.formValue.prevYearValue2) || this.state.formValue.prevYearValue2.length <= 0) {
            fieldErrors.prevYearValue2 = "Previous Year2 Value is required field.";
            isValid = true;
        } else fieldErrors.prevYearValue2 = "";

        if (!this.checkNull(this.state.formValue.prevYearValue3) || this.state.formValue.prevYearValue3.length <= 0) {
            fieldErrors.prevYearValue3 = "Previous Year3 Value is required field.";
            isValid = true;
        } else fieldErrors.prevYearValue3 = "";

        return isValid;
    };

    saveDiversityFinancialInfo = (e, isNavigate) => {
        e.preventDefault();
        this.formError = this.validateOnSubmit();
        if (this.formError) {
            if (this.state.showDiversity === true) {
                let userData = { "diverseCert": this.state.formValue.proSuppCertCd, "prosSuppId": this.state.prosSuppId };
                fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/updateSupplier", {
                    method: "POST",
                    body: JSON.stringify(userData),
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Basic " + getAuthToken()
                    }
                }).then((response) => {
                    if (response.status === 401 || response.status === 403) {
                        window.location.href = "/error";
                    }
                    this.saveSupplierdiversity(isNavigate);
                });
            } else {
                this.saveSupplierdiversity(isNavigate);
            }
        }
    }

    saveSupplierdiversity = (isNavigate) => {
        if (this.state.showDiversity === true) {
            let userData = this.state.diversityInfoJson;
            fetch(baseurl.DIVERSITY_API_URL + "diversity/saveDiversity", {
                method: "POST",
                body: JSON.stringify(userData),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Basic " + getAuthToken()
                }
            }).then((response) => {
                if (response.status === 401 || response.status === 403) {
                    window.location.href = "/error";
                }
                this.saveGeographical(isNavigate);
            });
        } else {
            this.saveGeographical(isNavigate);
        }
    }

    saveGeographical = (isNavigate) => {
        let userData = this.state.geographicalJson;
        fetch(baseurl.FINACIAL_API_URL + "financial/saveGeographical", {
            method: "POST",
            body: JSON.stringify(userData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then((response) => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            if (this.state.isFinancialDataExist === true) {
                this.updateFinancialinfo(isNavigate);
            } else {
                this.saveFinancialinfo(isNavigate);
            }
        });
    }

    saveFinancialinfo = (isNavigate) => {
        let jsonData = this.state.formValue;
        fetch(baseurl.FINACIAL_API_URL + "financial/saveFinancial", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then((response) => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            window.scrollTo(0, 0);
            if (isNavigate)
                document.location.href = "/commodity-info/" + this.state.prosNumber;
            else
                this.setState({ successMsg: "Saved Successfuly!" });
        }).catch(error => {
            this.setState({ errorMsg: error });
            window.scrollTo(0, 0);
        });
    }

    updateFinancialinfo = (isNavigate) => {
        let jsonData = this.state.formValue;
        fetch(baseurl.FINACIAL_API_URL + "financial/updateFinancial", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then((response) => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            window.scrollTo(0, 0);
            if (isNavigate)
                document.location.href = "/commodity-info/" + this.state.prosNumber;
            else
                this.setState({ successMsg: "Updated Successfuly!" });
        }).catch(error => {
            this.setState({ errorMsg: error });
            window.scrollTo(0, 0);
        });
    }

    checkNull = (value) => {
        let isValid = false;
        if (value !== undefined && value != null)
            isValid = true;
        return isValid;
    }

    getCheckboxCount = (jsonValue) => {
        let count1 = 0;
        jsonValue.filter((jsonObj) => jsonObj.isSelected === true).map(() => {
            count1++;
        })
        return count1;
    }

    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    getStandardCertName = (certId) => {
        let textValue = "";
        let jsonData = this.state.standardCertOptions;
        jsonData.map((standardCertOptObj) => {
            if (certId === standardCertOptObj.value) {
                textValue = standardCertOptObj.display;
            }
        })
        return textValue;
    }

    render() {
        return (
            <div>
                <Header pageHeading="Prospective Supplier" />
                <div className="container-fluid bg-light">
                    <Container className="bg-light">
                        <br />
                        <div className="row">
                            <span className="col-sm-24">
                                <h3>John Deere Prospective Supplier Application Form</h3>
                            </span>
                        </div>
                        <br />
                        <div className="row">
                            <span className="col-sm-8">
                                <CompanyleftHeader companyInfoObj={this.state.companyInfo} />
                            </span>
                            <span className="col-sm-16">
                                <div className="row">
                                    <div className="col-sm-24">
                                        <SuccessMsg message={this.state.successMsg} />
                                        <ErrorMsg message={this.state.errorMsg} />
                                    </div>
                                </div>
                                {this.state.showDiversity === true ?
                                    <div className="row">
                                        <div className="col-sm-24">
                                            <div><label className="uxf-label">Are you a Small Diverse Certified Supplier?</label></div>
                                            <div className="btn-group btn-group-toggle" data-toggle="buttons" role="group">
                                                <label className={this.state.formValue.proSuppCertCd === "Y" ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                                    <input
                                                        type="radio" name="proSuppCertCd"
                                                        id="YesSmallDivCertSupp"
                                                        autoComplete="off"
                                                        value="Y"
                                                        {...this.state.formValue.proSuppCertCd === "Y" ? "checked" : ""}
                                                        onChange={(event) => this.handleInput(event)} />Yes</label>
                                                <label className={this.state.formValue.proSuppCertCd === "N" ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                                    <input
                                                        type="radio" name="proSuppCertCd"
                                                        id="NoSmallDivCertSupp"
                                                        autoComplete="off"
                                                        value="N"
                                                        {...this.state.formValue.proSuppCertCd === "N" ? "checked" : ""}
                                                        onChange={(event) => this.handleInput(event)} />No</label>
                                            </div><div className="error">{this.state.formErrors.proSuppCertCd}</div>
                                        </div>
                                    </div>
                                    : null
                                }
                                {this.state.showDiversity === true && this.state.showClassifications === true ?
                                    <div className="row">
                                        <div className="col-sm-24">
                                            <div><label className="uxf-label">Classification(s)</label></div>
                                            <div className="btn-group-toggle" data-toggle="buttons" role="group">
                                                {this.state.diversityInfoJson.map((result, index) =>
                                                    <label className={result.isSelected === true ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                                        <input
                                                            type="checkbox" name="proSuppCerts"
                                                            id={"SuppCerts" + index}
                                                            autoComplete="off"
                                                            value={result.proSuppCertId}
                                                            {...result.isSelected === true ? "checked" : ""}
                                                            onChange={(event) => this.handleInput(event)} />{result.proSuppCertName}</label>
                                                )}
                                            </div><span className="error">{this.state.formErrors.proSuppCerts}</span>
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="row">
                                    <div className="col-sm-24">
                                        <h3 className="component-section-title">Financial Information</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-8">
                                        <div className="form-group">
                                            <Select
                                                title={"Business Type"}
                                                name={"businessTypeCd"}
                                                options={this.state.businessTypeOptions}
                                                value={this.state.formValue.businessTypeCd}
                                                handleChange={this.handleInput}
                                                defaultValue={""}
                                            />{" "}<span className="error">{this.state.formErrors.businessTypeCd}</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-7">
                                        <div><label className="uxf-label">Private or Public Traded</label></div>
                                        <div className="btn-group btn-group-toggle" data-toggle="buttons" role="group">
                                            <label className={this.state.formValue.tradedCd === "PRI" ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                                <input
                                                    type="radio" name="tradedCd"
                                                    id="PrivateTraded"
                                                    autoComplete="off"
                                                    value="PRI"
                                                    {...this.state.formValue.tradedCd === "PRI" ? "checked" : ""}
                                                    onChange={(event) => this.handleInput(event)} />Private</label>
                                            <label className={this.state.formValue.tradedCd === "PUB" ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                                <input
                                                    type="radio" name="tradedCd"
                                                    id="PublicTraded"
                                                    autoComplete="off"
                                                    value="PUB"
                                                    {...this.state.formValue.tradedCd === "PUB" ? "checked" : ""}
                                                    onChange={(event) => this.handleInput(event)} />Public</label>
                                        </div><span className="error">{this.state.formErrors.tradedCd}</span>
                                    </div>
                                    <div className="col-sm-9">
                                        <Input
                                            type={"text"}
                                            name={"ownerLegalName"}
                                            title={"Full Legal Name of Owner"}
                                            value={this.state.formValue.ownerLegalName}
                                            handleChange={this.handleInput}
                                            maxLength="60"
                                        /><span className="error">{this.state.formErrors.ownerLegalName}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-8">
                                        <Input
                                            type={"number"}
                                            name={"establishedYear"}
                                            title={"Year Established"}
                                            value={this.state.formValue.establishedYear}
                                            handleChange={this.handleInput}
                                            maxLength="4"
                                            onInput={this.maxLengthCheck}
                                        /><span className="error">{this.state.formErrors.establishedYear}</span>
                                    </div>
                                    <div className="col-sm-7">
                                        <Input
                                            type={"number"}
                                            name={"noFacilities"}
                                            title={"Number of Facilities"}
                                            value={this.state.formValue.noFacilities}
                                            handleChange={this.handleInput}
                                            maxLength="11"
                                            onInput={this.maxLengthCheck}
                                        /><span className="error">{this.state.formErrors.noFacilities}</span>
                                    </div>
                                    <div className="col-sm-9">
                                        <Input
                                            type={"number"}
                                            name={"noTotalEmployee"}
                                            title={"Total Number of Employees"}
                                            value={this.state.formValue.noTotalEmployee}
                                            handleChange={this.handleInput}
                                            maxLength="11"
                                            onInput={this.maxLengthCheck}
                                        /><span className="error">{this.state.formErrors.noTotalEmployee}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-24">
                                        <div><label className="uxf-label">Geographical Service Area</label></div>
                                        <div className="btn-group-toggle" data-toggle="buttons" role="group">
                                            {this.state.geographicalJson.map((result, index) =>
                                                <label className={result.isSelected === true ? "btn uxf-btn-toggle active" : "btn uxf-btn-toggle"}>
                                                    <input
                                                        type="checkbox" name="geographicalChk"
                                                        id={"Geographical" + index}
                                                        autoComplete="off"
                                                        value={result.geographicalId}
                                                        {...result.isSelected === true ? "checked" : ""}
                                                        onChange={(event) => this.handleInput(event)} />{result.geographicalName}</label>
                                            )}
                                        </div><span className="error">{this.state.formErrors.proGeographical}</span>
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col-sm-24">
                                        <div><label className="uxf-label">Previous Year Sales</label></div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Select
                                            title={""}
                                            name={"prevYearCurrencyCd"}
                                            options={this.state.prevYearSalesOptions}
                                            value={this.state.formValue.prevYearCurrencyCd}
                                            handleChange={this.handleInput}
                                            defaultValue={""}
                                        />{" "}<span className="error">{this.state.formErrors.prevYearCurrencyCd}</span>
                                        {this.state.showCurrencyRate ?
                                            <span className="currency">Current Conversion Rate: {this.state.currencyRate}</span>
                                            : ""}
                                    </div>
                                    <div className="col-sm-6">
                                        <Input
                                            type={"number"}
                                            name={"prevYearValue1"}
                                            title={""}
                                            value={this.state.formValue.prevYearValue1}
                                            handleChange={this.handleInput}
                                            maxLength="19"
                                            onInput={this.maxLengthCheck}
                                            placeholder={this.state.formValue.prevYearTitle1}
                                        /><span className="error">{this.state.formErrors.prevYearValue1}</span>
                                        {this.state.showYear1Currency ?
                                            <span className="currency" style={{ textAlign: 'right' }}>USD: {this.state.prevYear1ConvAmt}</span>
                                            : ""}
                                    </div>
                                    <div className="col-sm-6">
                                        <Input
                                            type={"number"}
                                            name={"prevYearValue2"}
                                            title={""}
                                            value={this.state.formValue.prevYearValue2}
                                            handleChange={this.handleInput}
                                            maxLength="19"
                                            onInput={this.maxLengthCheck}
                                            placeholder={this.state.formValue.prevYearTitle2}
                                        /><span className="error">{this.state.formErrors.prevYearValue2}</span>
                                        {this.state.showYear2Currency ?
                                            <span className="currency" style={{ textAlign: 'right' }}>USD: {this.state.prevYear2ConvAmt}</span>
                                            : ""}
                                    </div>
                                    <div className="col-sm-6">
                                        <Input
                                            type={"number"}
                                            name={"prevYearValue3"}
                                            title={""}
                                            value={this.state.formValue.prevYearValue3}
                                            handleChange={this.handleInput}
                                            maxLength="19"
                                            onInput={this.maxLengthCheck}
                                            placeholder={this.state.formValue.prevYearTitle3}
                                        /><span className="error">{this.state.formErrors.prevYearValue3}</span>
                                        {this.state.showYear3Currency ?
                                            <span className="currency">USD: {this.state.prevYear3ConvAmt}</span>
                                            : ""}
                                    </div>
                                </div>
                                {/*
                                <div className="row">
                                    <div className="col-sm-24">
                                        <div><label className="uxf-label">Standard Certifications</label></div>
                                    </div>
                                </div>

                                {this.state.standardCertFileList.map((result, i) => (
                                    <div className="row">
                                        <div className="col-sm-24">
                                            {result !== "Select a file" ?
                                                <div className="row">
                                                    <div className="col-sm-8">
                                                        <label>{this.getStandardCertName(result.split('|')[1].trim())}</label>
                                                        {" "}<span className="error">{this.state.formErrors.standardCerts[i]}</span>
                                                    </div>
                                                    <div className="col-sm-16">
                                                        <a href="#" onClick={(event) => this.downloadStandardCertFile(event, result)}>{result.split('|')[2].trim()}</a>&nbsp;&nbsp;&nbsp;
                                                        <a href="#" onClick={(event) => this.deleteStandardCertFile(event, result)}><img title="Delete" src={deleteIconUrl} style={{ alignSelf: "center", height: 33, width: 33 }} /></a>
                                                    </div>
                                                </div>
                                                :
                                                <div className="row">
                                                    <div className="col-sm-8">
                                                        <Select
                                                            title={""}
                                                            name={"standardCerts"}
                                                            options={this.state.standardCertOptions}
                                                            value={result.split('|')[1]}
                                                            handleChange={this.handleInput}
                                                            defaultValue={""}
                                                        />{" "}
                                                    </div>
                                                    <div className="col-sm-16">
                                                        <input type="file"
                                                            id={"StandardCertFile" + i}
                                                            className="custom-file-input"
                                                            indexCount={i}
                                                            onChange={(event) => this.saveStandardCertFile(event)}
                                                        />
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <label className="btn btn-outline-primary uxf-file-input input-group-text" for={"StandardCertFile" + i}>Browse</label>
                                                            </div>
                                                            <span> <input type="text" className="form-control" value={this.state.standardCertSelectedFile} disabled /></span>
                                                        </div>
                                                        <span className="error">{this.state.formErrors.standardCerts[i]}</span>
                                                    </div>
                                                </div>
                                                
                                            }
                                        </div>
                                    </div>
                                ))}


                                <div className="row">
                                    <div className="col-sm-24" style={{ textAlign: 'right' }}>
                                        <Button type={"warning"} action={this.addStandardCertFile} title={"+Add Another"} />{" "}
                                    </div>
                                </div>
                                */}
                                <div className="row">
                                    <div className="col-sm-24">
                                        <label className="uxf-label">Comments</label>
                                    </div>
                                </div>
                                <div className ="row">
                                <div className="col-sm-24">
                                <TextArea
                                    name={"comments"}
                                    placeholder={"Add Comment"}
                                    rows={"4"}
                                    cols={"500"}
                                    value={this.state.formValue.comments}
                                    handleChange={this.handleInput}
                                    maxLength="450"
                                />{" "}
                                </div>
                                </div><br/>
                                <div className="row">
                                    <div className="col-sm-24" style={{ textAlign: 'right' }}>
                                        <Button type={"warning"} title={"Save"} action={this.onClickSave} />{" "}<Button type={"warning"} title={"Continue"} isNavigate="true" action={this.onClickContinue} />{" "}
                                    </div>
                                </div><br />
                            </span>
                        </div>
                    </Container>
                </div>
                <Footer />
            </div>
        );
    }
}
export default DiversityFinacialInfo;